module.exports = __webpack_public_path__ + "static/media/ors2.png.bc408396.jpg";